import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Refund from "./views/refundOrder/Refund";
import Orders from "./views/Orders";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Orders />} />
          <Route path="/refund-order/:id" element={<Refund />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
